import * as React from 'react';
import { SVGProps } from 'react';

export const Backrest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.01052 28.0747C7.78462 28.0747 7.77079 28.0655 7.73391 28.0516C7.63709 28.0055 7.58638 27.9041 7.60482 27.8027L8.25025 24.179C8.2733 24.0546 8.39317 23.967 8.51764 23.9946C8.64212 24.0177 8.7251 24.1375 8.70205 24.262L8.10272 27.6183C8.27791 27.6183 8.51303 27.6183 8.75277 27.609L10.0851 24.1375C10.1312 24.0177 10.2649 23.9624 10.3848 24.0038C10.5047 24.0499 10.5646 24.1836 10.5185 24.3035L9.1308 27.9179C9.09853 28.0055 9.01094 28.0655 8.91873 28.0655C8.44849 28.0701 8.17649 28.0747 8.01052 28.0747Z"
      fill="#35383A"
      stroke="#071114"
      strokeWidth="0.8"
    />
    <path
      d="M7.36967 10.6111C7.24059 10.6111 7.13916 10.5096 7.13916 10.3806V7.24099C7.13916 5.45222 8.59138 4 10.3801 4H24.4598C24.5889 4 24.6903 4.10142 24.6903 4.23051C24.6903 4.3596 24.5889 4.46102 24.4598 4.46102H10.3801C8.84955 4.46102 7.60479 5.70578 7.60479 7.23638V10.3759C7.60479 10.505 7.50337 10.6065 7.37428 10.6065L7.36967 10.6111Z"
      fill="#35383A"
      stroke="#071114"
      strokeWidth="0.8"
    />
    <path
      d="M24.4598 23.114L5.39648 23.1048C5.1798 23.1048 5 22.925 5 22.7083V13.8567C5 12.635 5.9912 11.6438 7.21291 11.6438H7.53562C8.75733 11.6438 9.74853 12.635 9.74853 13.8567V18.9464H26.7695C26.8986 18.9464 27 19.0478 27 19.1769C27 19.306 26.8986 19.4074 26.7695 19.4074H9.51341C9.38433 19.4074 9.2829 19.306 9.2829 19.1769V13.8567C9.2829 12.8932 8.49916 12.1048 7.53101 12.1048H7.2083C6.24476 12.1048 5.45641 12.8886 5.45641 13.8567V22.6438L24.4552 22.653C24.5842 22.653 24.6857 22.7544 24.6857 22.8835C24.6857 23.0126 24.5842 23.114 24.4552 23.114H24.4598Z"
      fill="#35383A"
      stroke="#071114"
      strokeWidth="0.8"
    />
    <path
      d="M22.5191 19.2784C22.39 19.2784 22.2886 19.177 22.2886 19.0479V6.58183C22.2886 6.45274 22.39 6.35132 22.5191 6.35132C22.6482 6.35132 22.7496 6.45274 22.7496 6.58183V19.0479C22.7496 19.177 22.6482 19.2784 22.5191 19.2784Z"
      fill="#35383A"
      stroke="#071114"
      strokeWidth="0.8"
    />
    <g opacity="0.2">
      <mask
        id="mask0_4454_84538"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="17"
        height="17"
      >
        <path
          d="M22.5418 4.17065H7.36035V19.1723H22.5418V4.17065Z"
          fill="white"
          stroke="white"
          strokeWidth="0.8"
        />
      </mask>
      <g mask="url(#mask0_4454_84538)">
        <path
          d="M7.36035 9.87353V11.8467C7.36035 11.8467 8.51752 11.6761 9.11685 12.6627C9.71618 13.6493 9.5456 14.5944 9.5456 14.5944L9.51333 19.177L22.5188 19.0525L22.5418 4.17529H10.191C10.191 4.17529 7.76605 4.2214 7.36957 7.2457L7.36035 9.88275V9.87353Z"
          fill="#071114"
          stroke="#071114"
          strokeWidth="0.8"
        />
      </g>
    </g>
    <path
      d="M26.6819 16.7013H11.3252C11.1962 16.7013 11.0947 16.5998 11.0947 16.4707C11.0947 16.3417 11.1962 16.2402 11.3252 16.2402H26.6819C26.811 16.2402 26.9124 16.3417 26.9124 16.4707C26.9124 16.5998 26.811 16.7013 26.6819 16.7013Z"
      fill="#35383A"
      stroke="#071114"
      strokeWidth="0.8"
    />
  </svg>
);
export default Backrest;
